export const GENERAL_UNDO = 'GENERAL_UNDO'
export const SET_GDPR_DATA = 'SET_GDPR_DATA'
export const ON_CHANGE = 'GENERAL_ON_CHANGE'
export const SET_PDF_VIEWER = 'SET_PDF_VIEWER'
export const SET_DEFAULT_TAB = 'SET_DEFAULT_TAB'
export const GENERAL_PRESENT = 'GENERAL_PRESENT'
export const DISPLAY_USERS_BY = 'DISPLAY_USERS_BY'
export const SET_DASHBOARD_TYPE = 'SET_DASHBOARD_TYPE'
export const ON_CHANGE_GDPR = 'GENERAL_ON_CHANGE_GDPR'
export const GENERAL_PAGE_STATUS = 'GENERAL_PAGE_STATUS'
export const GENERAL_SETTINGS_ID = 'GENERAL_SETTINGS_ID'
export const GENERAL_PAGE_SAVING = 'GENERAL_PAGE_SAVING'
export const TOGGLE_WELCOME_EMAIL = 'TOGGLE_WELCOME_EMAIL'
export const SET_GENERAL_SETTINGS = 'SET_GENERAL_SETTINGS'
export const TOGGLE_GDPR_PAGE = 'GENERAL_TOGGLE_GDPR_PAGE'
export const SET_DISCLAIMER_SHOWING = 'SET_DISCLAIMER_SHOWING'
export const GENERAL_SETTINGS_LOADED = 'GENERAL_SETTINGS_LOADED'
export const GENERAL_DISCLAIMER_AGREE = 'GENERAL_DISCLAIMER_AGREE'
export const TOGGLE_DISCLAIMER_PAGE = 'GENERAL_TOGGLE_DISCLAIMER_PAGE'
export const ON_CHANGE_WELCOME_EMAIL_SEND = 'ON_CHANGE_WELCOME_EMAIL_SEND'
export const ON_TOGGLE_FIRST_EXTERNAL_LINK = 'ON_TOGGLE_FIRST_EXTERNAL_LINK'
export const ON_TOGGLE_SECOND_EXTERNAL_LINK = 'ON_TOGGLE_SECOND_EXTERNAL_LINK'
export const ON_TOGGLE_THIRD_EXTERNAL_LINK = 'ON_TOGGLE_THIRD_EXTERNAL_LINK'
export const ON_CHANGE_EXTERNAL_LINK = 'ON_CHANGE_EXTERNAL_LINK'
export const GET_EXTERNAL_LINKS = 'GET_EXTERNAL_LINKS'
export const SET_CERTIFICATE_TYPE = 'SET_CERTIFICATE_TYPE'
export const SET_CONTACT_EMAIL = 'SET_CONTACT_EMAIL'
export const GET_EXTERNAL_APPS = 'GET_EXTERNAL_APPS'
export const ENABLE_USER_REWARDS = 'ENABLE_USER_REWARDS'
export const ENABLE_LEADERBOARD = 'ENABLE_LEADERBOARD'
export const ENABLE_MANAGER_ALERT = 'ENABLE_MANAGER_ALERT'
export const ENABLE_CORPORATE_HIERARCHY = 'ENABLE_CORPORATE_HIERARCHY'
export const ENABLE_PDFJS_DOWNLOAD_AND_PRINT = 'ENABLE_PDFJS_DOWNLOAD_AND_PRINT'
export const ALLOW_SIGNUP = 'ALLOW_SIGNUP'
export const ASK_COUNTRY = 'ASK_COUNTRY'
export const ASK_AGE = 'ASK_AGE'
export const ENABLE_COMBOARD_NOTIFICATIONS = 'ENABLE_COMBOARD_NOTIFICATIONS'
export const SET_IS_BLOCKING = 'SET_IS_BLOCKING'

export const SET_MESSAGES_ARCHIVE_PERIOD = 'SET_MESSAGES_ARCHIVE_PERIOD'
export const ENABLE_CERTIFICATE_FOOTER = 'ENABLE_CERTIFICATE_FOOTER'
export const ON_CHANGE_CERTIFICATE_FOOTER = 'ON_CHANGE_CERTIFICATE_FOOTER'
export const ENABLE_PUBLIC_CATALOG_PERCENTAGE =
  'ENABLE_PUBLIC_CATALOG_PERCENTAGE'
export const ALLOW_ALL_LOCATIONS_ACESS = 'ALLOW_ALL_LOCATIONS_ACESS'
export const ENABLE_LANGUAGE_FILES = 'ENABLE_LANGUAGE_FILES'
export const AUTO_COMPLETE_FORMS = 'AUTO_COMPLETE_FORMS'
export const DISABLE_LOCATION_FORMS = 'DISABLE_LOCATION_FORMS'
export const SET_SHOW_SIDEBAR_CHILD_ROUTES = 'SET_SHOW_SIDEBAR_CHILD_ROUTES'
